export class VerifyEmailCodeResponsetModel {
    user_email: string;
    verification_jwt: string;
    verification_code_email_sent: boolean;
    verification_code_expiration_ms: string;
    verification_code_expiration_minutes: string;
    verification_code_expiration_datetime: string;
    verification_retrys_remaining: number;
}
